import { apiSlice } from '../../../../app/apiSlice';
import { formatDateToISO } from '../../../../utils/formatDate';
import configSiteUrls from '../../configs/configSiteUrls';
import { CentroApoioListPublicResponse } from './types/CentroApoio';
import { CentroApoioAnexo } from './types/CentroApoioAnexo';

//usei o centroApoioAnexo como base

const endpointUrl = configSiteUrls.SITE_CENTRO_APOIO_EP;
const endpointUrlPublic = configSiteUrls.SITE_CENTRO_APOIO_PUBLIC_EP;

interface Params {
  data_inicial?: string | null;
  data_final?: string | null;
  search?: string | null;
  page?: number;
  apply?: boolean;
  exercicio?: string | null;
  tipo?: string | null;
}

function getcentroApoiosPublic({ data_inicial, data_final, search, page = 1, exercicio, tipo }: Params) {
  const queryParams = new URLSearchParams();

  if (search) queryParams.set('search', search);
  if (data_inicial) queryParams.set('dataInicial', formatDateToISO(data_inicial));
  if (data_final) queryParams.set('dataFinal', formatDateToISO(data_final));
  queryParams.set('page', page.toString());
  if (exercicio) queryParams.set('exercicio', exercicio);
  if (tipo) queryParams.set('tipo', tipo);

  return {
    url: `${endpointUrlPublic}/all?${queryParams.toString()}`,
    method: 'GET'
  };
}

function getCentroApoioAnexos({ idCentroApoioAnexo }: { idCentroApoioAnexo: string }) {
  if (!idCentroApoioAnexo) {
    return {
      url: '',
      method: ''
    };
  }
  return {
    url: `${endpointUrlPublic}/anexos?idn=${idCentroApoioAnexo}&respostaAnexo=false`,
    method: 'GET'
  };
}

function getCentroApoioAnexosResposta({ idCentroApoioAnexo }: { idCentroApoioAnexo: string }) {
  if (!idCentroApoioAnexo) {
    return {
      url: '',
      method: ''
    };
  }
  return {
    url: `${endpointUrlPublic}/anexos?idn=${idCentroApoioAnexo}&respostaAnexo=true`,
    method: 'GET'
  };
}

function addAnexos(formData: FormData) {
  return {
    url: `${endpointUrlPublic}/anexos/create`,
    method: 'POST',
    body: formData
    //headers: { "Content-Type": "multipart/form-data" }, // não precisa, o fetchBaseQuery já lida com isso
  };
}

//addAnexosResposta
function addAnexosResposta(formData: FormData) {
  return {
    url: `${endpointUrl}/anexos/create`,
    method: 'POST',
    body: formData
    //headers: { "Content-Type": "multipart/form-data" }, // não precisa, o fetchBaseQuery já lida com isso
  };
}

function removeAnexosExcluidos(formData: FormData) {
  return {
    url: `${endpointUrl}/remover-anexos`,
    method: 'POST',
    body: formData
    //headers: { "Content-Type": "multipart/form-data" }, // não precisa, o fetchBaseQuery já lida com isso
  };
}

export const centroApoioAnexoApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getCentroApoioAnexos: query<CentroApoioAnexo[], { idCentroApoioAnexo: string }>({
      query: getCentroApoioAnexos,
      providesTags: ['CentroApoioAnexoSite']
    }),
    getCentroApoioAnexosResposta: query<CentroApoioAnexo[], { idCentroApoioAnexo: string }>({
      query: getCentroApoioAnexosResposta,
      providesTags: ['CentroApoioAnexoSite']
    }),
    getcentroApoiosPublic: query<CentroApoioListPublicResponse, Params>({
      query: getcentroApoiosPublic,
      providesTags: ['CentroApoioAnexoSite']
    }),

    addCentroApoioAnexos: mutation<void, FormData>({
      query: addAnexos,
      invalidatesTags: ['CentroApoioAnexoSite']
    }),
    addCentroApoioAnexosResposta: mutation<void, FormData>({
      query: addAnexosResposta,
      invalidatesTags: ['CentroApoioAnexoSite']
    }),
    removeCentroApoioAnexoExcluido: mutation<void, FormData>({
      query: removeAnexosExcluidos,
      invalidatesTags: ['CentroApoioAnexoSite']
    })
  })
});
export const {
  useGetCentroApoioAnexosQuery,
  useAddCentroApoioAnexosMutation,
  useRemoveCentroApoioAnexoExcluidoMutation,
  useLazyGetCentroApoioAnexosQuery,
  useGetCentroApoioAnexosRespostaQuery,
  useGetcentroApoiosPublicQuery,
  useLazyGetcentroApoiosPublicQuery,
  useAddCentroApoioAnexosRespostaMutation
} = centroApoioAnexoApiSlice;
